import {
  ClipboardListIcon,
  HistoryIcon,
  HomeIcon,
  InboxIcon,
  SearchIcon,
  StarIcon,
  TrashIcon,
  UsersIcon,
} from 'lucide-react';
import {ReactElement} from 'react';

export const driveSidebarIcons: Record<string, ReactElement> = {
  '/drive': <HomeIcon />,
  '/drive/search': <SearchIcon />,
  '/drive/recent': <HistoryIcon />,
  '/drive/starred': <StarIcon />,
  '/drive/shares': <UsersIcon />,
  '/drive/file-requests': <InboxIcon />,
  '/drive/trash': <TrashIcon />,
  '/drive/delete-requests': <ClipboardListIcon />,
};
